import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 13 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 7L4.33333 11L12 1",
		stroke: "#66B913",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgCheck;
